import {
  DataObjectId,
  DealActivityDealItem,
  Hub,
  isDealActivityDealItem
} from 'yougile-model'
import {Sync} from '@client/sync'
import {crmStore} from '../crm/crm-store'
import {getDealActivity} from '../right-panel/crm/deal-history/get-deal-activity'

export interface FullBoardDealReport {
  [taskId: DataObjectId]: {
    task: Hub
    activity: DealActivityDealItem[]
    organization: Hub | undefined
    contactPerson: Hub | undefined
  }
}

export const getFullBoardDealReport = (
  board: Hub,
  assigned?: DataObjectId[]
): FullBoardDealReport => {
  const box = Sync.get(board)
  const tasks: Hub[] = []
  box.walkForward(board, (obj, level) => {
    if (level === 2 && !obj.deleted && !obj.title.startsWith('.')) {
      tasks.push(obj)
      return false
    }
    return true
  })

  const result: FullBoardDealReport = {}

  tasks.forEach(task => {
    const activity = getDealActivity(task)
    if (activity) {
      const organization = crmStore.getOrganization(task.id)
      const contactPerson = crmStore.getContactPerson(task.id)

      result[task.id] = {
        task,
        activity: activity
          .filter(activity => {
            if (!isDealActivityDealItem(activity)) {
              return false
            }

            if (assigned?.length) {
              return activity.assigned?.some(id => assigned.includes(id))
            }

            return true
          })
          .filter(isDealActivityDealItem),
        organization,
        contactPerson
      }
    }
  })

  return result
}
